import { path as r_Path} from 'ramda'
import { dateStrToISODate } from './generalHelpers.js'

const value = (obj, key) => r_Path(key.split('.'), obj)

export const getFirstItem = (arr = [], nestingKey = 'children') => {
  if (arr.length > 0) {
    if (!arr[0][nestingKey]) return arr[0]
    return getFirstItem(arr[0][nestingKey])
  }
}

export const fieldByKey = (objects = [], key, field) => objects.reduce((dictionary, obj) => {
  dictionary[value(obj, key)] = obj[field]
  return dictionary
}, {})

export const toDictionary = (objects, key, dictionary = {}) => objects && objects.reduce((dic, obj) => {
  const newKey = value(obj, key)
  if (newKey) dic[newKey] = obj
  return dic
}, dictionary)

export const toObject = (array, value) => array && array.reduce(
  (obj, item) => {
    obj[item] = value
    return obj
  },
  {}
)

export const findInTree = (arr, value, fieldName, nestingKey = 'children') => {
  if (!Array.isArray(arr)) return null

  for (const node of arr) {
    if (node[fieldName] === value) return node

    const children = node[nestingKey]
    if (Array.isArray(children) && children.length > 0) {
      const foundInChildren = findInTree(children, value, fieldName, nestingKey)
      if (foundInChildren) return foundInChildren
    }
  }

  return null
}

// comparison functions for sorting
export const byStringValue = (a, b) => a < b ? -1 : (a > b ? 1 : 0)
export const byEnglishFirst = (lang1, lang2) => {
  const a = lang1 ? lang1.toLowerCase() : ''
  const b = lang2 ? lang2.toLowerCase() : ''
  if (a.startsWith('en')) {
    if (b.startsWith('en')) return byStringValue(a, b)
    return -1
  } else if (b.startsWith('en')) return 1
  return byStringValue(a, b)
}

export const sortStrings = (arr) => [...arr].sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
export const sortDates = array => !Array.isArray(array) ? array : array.sort((a, b) => dateStrToISODate(b) - dateStrToISODate(a))
export const firstOrEmptyObj = (array = []) => array[0] || {}

export const processInBatches = async (items, handler, BATCH_SIZE = 5, DELAY_MS = 100) => {
  const results = []

  for (let i = 0; i < items.length; i += BATCH_SIZE) {
    const batch = items.slice(i, i + BATCH_SIZE)
    const batchResults = await Promise.all(batch.map(handler))
    results.push(...batchResults)
    await new Promise(resolve => setTimeout(resolve, DELAY_MS))
  }

  return results
}
